import type { entretien as Fr } from '../fr/entretien';

/** « entretien » in English — typed on the French: a missing sentence does not compile. */
export const entretien: typeof Fr = {
  erreur: 'Error',
  titre: 'Maintenance',
  resume: (n: number, total: string) => `${n} ${n === 1 ? 'job' : 'jobs'} · ${total} spent`,
  surTotal: (n: number) => ` · out of ${n} in total`,
  voirInterventions: 'Show jobs',
  voirBilan: 'Show summary',
  enregistrer: 'Record maintenance',
  depense: 'Spent on maintenance',
  joursImmo: 'Days off the road',
  manque: 'Lost revenue',
  manqueAide: 'on those days, the vehicle could not be rented',
  coutReel: 'Real cost',
  coutReelAide: 'invoice + downtime',
  parVoiture: 'By vehicle',
  colBilan: {
    vehicule: 'Vehicle', interventions: 'Jobs', depense: 'Spent', jours: 'Days off the road',
    manque: 'Lost revenue', prochaine: 'Next service due',
  },
  coutPar: (u: string) => `Cost / 1,000 ${u}`,
  noteBilan: (u: string) => `Lost revenue is calculated at the vehicle’s rate: a vehicle at the garage earns nothing. Cost per 1,000 ${u} lets you compare vehicles that are not driven as much.`,
  alerte: (ech: string, compteur: string, reste: string, u: string) =>
    `Next service due at ${ech} ${u}, the odometer reads ${compteur} ${u} — ${reste} ${u} to go.`,
  toutesVoitures: 'All vehicles',
  tousMois: 'All months',
  toutVoir: 'Show all',
  interventions: 'Jobs',
  aucun: 'No maintenance recorded',
  aucunFiltre: 'No jobs for this filter',
  col: { date: 'Date', vehicule: 'Vehicle', intervention: 'Job', prestataire: 'Provider', km: 'Mileage', cout: 'Cost', immo: 'Off the road', prochaine: 'Next service due' },
  noteImmo: 'Entering a downtime period automatically blocks the vehicle on the planning board and in availability.',
  vehicule: 'Vehicle',
  choisir: 'Choose…',
  intervention: 'Job',
  types: {
    Vidange: 'Oil change', Pneus: 'Tyres', Plaquettes: 'Brake pads', 'Révision': 'Service',
    Panne: 'Breakdown', Carrosserie: 'Bodywork', Autre: 'Other',
  },
  date: 'Date',
  kilometrage: 'Mileage',
  cout: (d: string) => `Cost (${d})`,
  prestataire: 'Provider',
  payeCaisse: 'Paid from petty cash',
  payeCaisseAide: 'The amount comes out of the petty cash drawer. Untick if someone paid out of their own pocket.',
  immoDu: 'Off the road from',
  immoAu: 'to',
  prochaineKm: (u: string) => `Next service due (${u})`,
  prochaineKmAide: (u: string) => `You will be alerted 2,000 ${u} before.`,
  description: 'Description',
  annuler: 'Cancel',
  valider: 'Save',
};
